import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { Url } from 'lib/utils/url';

export const UPDATE_SEARCH_FIELD = 'UPDATE_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const UPDATE_SEARCH_SUGGESTIONS = 'UPDATE_SEARCH_SUGGESTIONS';
export const SET_SEARCH_SUGGESTION = 'SET_SEARCH_SUGGESTION';
export const SET_NEXT_SEARCH_SUGGESTION = 'SET_NEXT_SEARCH_SUGGESTION';
export const SET_PREVIOUS_SEARCH_SUGGESTION = 'SET_PREVIOUS_SEARCH_SUGGESTION';
export const RECEIVE_SEARCH_SUGGESTIONS_ERROR = 'RECEIVE_SEARCH_SUGGESTIONS_ERROR';

function normalizeSearchSuggestions(searchSuggestions) {
  const dataTransformed = searchSuggestions;
  if (dataTransformed.suggestions) {
    dataTransformed.suggestions = dataTransformed.suggestions.map((word) => word.toLowerCase());
  }
  if (dataTransformed.searchTerm) {
    dataTransformed.searchTerm = dataTransformed.searchTerm.trim().toLowerCase();
  }
  return dataTransformed;
}

export function search(entry) {
  return (dispatch, store, { router }) => {
    router.push(new Url('/search').addQueryParameter('entry', entry.trim()).toString());
  };
}

export function update(value) {
  return { type: UPDATE_SEARCH_FIELD, value };
}

export function clear() {
  return { type: CLEAR_SEARCH };
}

export function updateSearchSuggestions(searchSuggestions) {
  return { type: UPDATE_SEARCH_SUGGESTIONS, searchSuggestions };
}

export function receiveSearchSuggestionsError(json) {
  return {
    type: RECEIVE_SEARCH_SUGGESTIONS_ERROR,
    error: json.error,
  };
}

export function getSearchSuggestions(value) {
  return (dispatch, store, { network }) => network
    .get(new Url(`${config.apiBasePath}/search/suggestions`).addQueryParameter('searchTerm', value).toString())
    .then(data => {
      dispatch(updateSearchSuggestions(normalizeSearchSuggestions(data)));
    })
    .catch(err => {
      dispatch(receiveSearchSuggestionsError(err.data || UNKNOWN_ERROR));
    });
}

export function setSearchSuggestionAsSelected(suggestion) {
  return {
    type: SET_SEARCH_SUGGESTION,
    suggestion,
  };
}

export function setNextSearchSuggestionAsSelected() {
  return { type: SET_NEXT_SEARCH_SUGGESTION };
}

export function setPreviousSearchSuggestionAsSelected() {
  return { type: SET_PREVIOUS_SEARCH_SUGGESTION };
}
